<mat-toolbar>端末管理</mat-toolbar>
<div class="mat-elevation-z8">
  <div>
    <table mat-table #table [dataSource]="dataSource" matSort aria-label="Elements">
      <!-- Id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
        <td mat-cell *matCellDef="let row">{{row?.id}}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>端末名</th>
        <td mat-cell *matCellDef="let row">{{row?.name}}<div><span *ngIf="row?.isPWA" class="is-pwa">(携帯端末)</span><span *ngIf="serialId === row?.serialId" class="this-terminal">(本端末)</span></div></td>
      </ng-container>
      <ng-container matColumnDef="borderHour">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>営業日変更時間</th>
        <td mat-cell *matCellDef="let row">{{row?.borderHour}}</td>
      </ng-container>
      <ng-container matColumnDef="serialId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>シリアル番号</th>
        <td mat-cell *matCellDef="let row">{{row?.serialId}}</td>
      </ng-container>
      <ng-container matColumnDef="yakusyaTerminalId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>就業役者端末識別識別ID</th>
        <td mat-cell *matCellDef="let row">{{row?.yakusyaTerminalId}}</td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row">
          <button mat-raised-button (click)="openDialog(row)">編集</button>
        </td>
      </ng-container>
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row">
          <button mat-raised-button (click)="delete(row)">削除</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <button class="addButton" mat-raised-button (click)="openDialog({ id: '', name: '', borderHour: 5, serialId: '' ,yakusyaTerminalId: '', isPWA: false})">追加</button>
  </div>
  <mat-paginator #paginator [length]="dataSource?.data?.length" [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 250]">
  </mat-paginator>
</div>
